import {
  Button,
  Checkbox,
  Heading,
  Input,
  Text,
} from "../../components/common";
import { logo } from "../../images";
import { FaGoogle, FaGithub } from "react-icons/fa";

import classes from "./Login.module.css";
import clsx from "clsx";
import { useState } from "react";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [errors, setErrors] = useState({ email: false, password: false });

  const validateInputs = () => {
    const newErrors = {
      email: !email.match(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/), // Basic email regex
      password: password.length < 8, // Password should have at least 8 characters
    };
    setErrors(newErrors);

    // If no errors, return true
    return !newErrors.email && !newErrors.password;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Validate inputs
    if (validateInputs()) {
      console.log("Form submitted!");
    } else {
      console.log("Invalid inputs");
    }
  };

  return (
    <main className={classes.mainWrapper}>
      <form
        className={clsx(classes.wrapper, "container")}
        onSubmit={handleSubmit}
      >
        <img src={logo} alt="#" className={classes.logo} />
        <Heading xl font600 textCenter primary>
          Create your account
        </Heading>
        <div className={classes.buttonContainer}>
          <Button primitive700 wFull>
            <FaGoogle className={classes.icon} />
            Google
          </Button>{" "}
          <Button primitive700 wFull>
            <FaGithub className={classes.icon} />
            Github
          </Button>
        </div>
        <Text xs primitive400 textCenter>
          or
        </Text>
        <div className={classes.inputWrapper}>
          {(errors.email || errors.password) && (
            <Text className={classes.errorsContainer} xs>
              Invalid email or password. <br /> Please try again.
            </Text>
          )}
          <Input
            name="email"
            value={email}
            setValue={setEmail}
            type="email"
            placeholder="Email address"
            className={clsx((errors.email || errors.password) && classes.error)} // Add error class if email is invalid
          />

          <Input
            name="password"
            value={password}
            setValue={setPassword}
            type="password"
            placeholder="Password"
            className={clsx((errors.email || errors.password) && classes.error)} // Add error class if password is invalid
          />
        </div>{" "}
        <div className={classes.spaceBetween}>
          <Checkbox
            label="Remember me"
            checked={rememberMe}
            setChecked={setRememberMe}
          />

          <Button
            transparent
            to="/forgot-password"
            sm
            className={classes.button}
          >
            Forgot Password?
          </Button>
        </div>
        <Button type="submit" wFull>
          Login
        </Button>
        <div className={classes.doNotHave}>
          <Text sm primitive200>
            Don’t have an account?
          </Text>
          <Button transparent to="/sign-up" className={classes.button} sm>
            Sign Up Now
          </Button>
        </div>
      </form>
    </main>
  );
};

export default Login;
